/**
 * How much of the map's prop budget (`LIMITS.props`) the props already placed use up. ROUND7 laid walls in
 * 1.5 m pieces so that a breach is a gap, not a face - which turned one 12 m run into eight props, and since
 * scatter only gets what is left under the cap, walled maps lost 40-55 bushes and rocks of cover to a change
 * that was about walls. So a wall laid east-west counts by its length, as the long run it replaced
 * (`LINES.pieceMax`); a quarter-turned column piece counts one, as it always did. Everything else counts one.
 */

import { quarterTurned } from '../sim/props';
import type { PropDef } from '../sim/types';
import { LINES } from './tuning';

export function propLoad(props: readonly PropDef[]): number {
  let load = 0;
  for (const p of props) {
    load += p.kind === 'wall' && !quarterTurned(p.yaw) ? (p.length ?? LINES.pieceMax) / LINES.pieceMax : 1;
  }
  return load;
}
